const STYLES = {
  hot: 'bg-red-100 text-red-700 border-red-200 dark:bg-red-900/40 dark:text-red-300 dark:border-red-800',
  warm: 'bg-amber-100 text-amber-700 border-amber-200 dark:bg-amber-900/40 dark:text-amber-300 dark:border-amber-800',
  cold: 'bg-sky-100 text-sky-700 border-sky-200 dark:bg-sky-900/40 dark:text-sky-300 dark:border-sky-800',
};

export const LeadTriageBadge = ({ triage, testId }) => {
  if (!triage || triage.score == null) return null;
  const t = triage.temperature || 'warm';
  return (
    <span
      data-testid={testId || 'lead-triage-badge'}
      title={[triage.reason, triage.routing_reason].filter(Boolean).join(' — ')}
      className={`inline-flex items-center gap-1 rounded-full border px-2 py-0.5 text-[11px] font-medium shrink-0 ${STYLES[t] || STYLES.warm}`}
    >
      AI {triage.score} · {t}
    </span>
  );
};
